@if (paymentPhase === 'checkout') {
<div class="w-full flex flex-row gap-4">
  <div class="flex-1">
    <div sxPadding="medium medium large" sxBackground="light" sxRadius="medium" sxBorderColor="one" sxBorderWidth="1px">
      <h1 sxMargin="20px 0 15px 10px" sxTextSize="large" sxTextWeight="bold">Billing Details</h1>

      <form [formGroup]="billingForm" sxMargin="0 0 20px 0" novalidate>
        <div class="form-field">
          <ion-item class="custom-input" [class.error]="shouldShowError('billingName')">
            <ion-input placeholder="Billing Name *" formControlName="billingName"
              [class.error]="shouldShowError('billingName')" aria-label="Billing name"
              aria-describedby="billingName-error" [attr.aria-invalid]="shouldShowError('billingName')">
            </ion-input>
          </ion-item>
          @if (shouldShowError('billingName')) {
          <div class="error-message" id="billingName-error" role="alert">
            @if (billingForm.get('billingName')?.errors?.['required']) {
            <span>Billing Name is required</span>
            }
            @if (billingForm.get('billingName')?.errors?.['minlength']) {
            <span>Billing Name must be at least 2 characters</span>
            }
            @if (billingForm.get('billingName')?.errors?.['maxlength']) {
            <span>Billing Name must not exceed 100 characters</span>
            }
          </div>
          }
        </div>

        <h3 sxMargin="20px 0 10px 10px" sxColor="three" sxTextSize="medium" sxTextWeight="bold">Address</h3>

        <div class="form-field">
          <ion-item class="custom-input" [class.error]="shouldShowError('addressLine')">
            <ion-input placeholder="Street Address *" formControlName="addressLine"
              [class.error]="shouldShowError('addressLine')" aria-label="Street address"
              aria-describedby="addressLine-error" [attr.aria-invalid]="shouldShowError('addressLine')">
            </ion-input>
          </ion-item>
          @if (shouldShowError('addressLine')) {
          <div class="error-message" id="addressLine-error" role="alert">
            @if (billingForm.get('addressLine')?.errors?.['required']) {
            <span>Street Address is required</span>
            }
            @if (billingForm.get('addressLine')?.errors?.['minlength']) {
            <span>Street Address must be at least 5 characters</span>
            }
            @if (billingForm.get('addressLine')?.errors?.['maxlength']) {
            <span>Street Address must not exceed 200 characters</span>
            }
          </div>
          }
        </div>

        <div class="form-field">
          <ion-item class="custom-input" [class.error]="shouldShowError('zipCode')">
            <ion-input placeholder="Pincode *" formControlName="zipCode" [class.error]="shouldShowError('zipCode')"
              aria-label="Pincode" aria-describedby="zipCode-error" [attr.aria-invalid]="shouldShowError('zipCode')"
              type="tel" maxlength="6">
            </ion-input>
            @if (isFetchingAddress) {
            <ion-spinner slot="end" name="crescent" class="pincode-spinner" aria-label="Fetching address"></ion-spinner>
            }
          </ion-item>
          @if (shouldShowError('zipCode')) {
          <div class="error-message" id="zipCode-error" role="alert">
            @if (billingForm.get('zipCode')?.errors?.['required']) {
            <span>Pincode is required</span>
            }
            @if (billingForm.get('zipCode')?.errors?.['pattern']) {
            <span>Pincode must be 6 digits</span>
            }
          </div>
          }
          @if (manualAddressEntry) {
          <div class="error-message" role="alert">
            <span>Couldn't find this pincode — please fill City, State and Country manually</span>
          </div>
          }
        </div>

        <div sxRow sxGap="10px">
          <div class="form-field" sxWidth="fill">
            <ion-item class="custom-input" [class.readonly]="!manualAddressEntry"
              [class.error]="shouldShowError('city')">
              <ion-input placeholder="City *" formControlName="city" [readonly]="!manualAddressEntry"
                [class.error]="shouldShowError('city')" aria-label="City" aria-describedby="city-error"
                [attr.aria-invalid]="shouldShowError('city')">
              </ion-input>
            </ion-item>
            @if (shouldShowError('city')) {
            <div class="error-message" id="city-error" role="alert">
              @if (billingForm.get('city')?.errors?.['required']) {
              <span>Enter a valid pincode to fill the city</span>
              }
              @if (billingForm.get('city')?.errors?.['minlength']) {
              <span>City must be at least 2 characters</span>
              }
              @if (billingForm.get('city')?.errors?.['maxlength']) {
              <span>City must not exceed 50 characters</span>
              }
            </div>
            }
          </div>

          <div class="form-field" sxWidth="fill">
            <ion-item class="custom-input" [class.readonly]="!manualAddressEntry"
              [class.error]="shouldShowError('state')">
              <ion-input placeholder="State *" formControlName="state" [readonly]="!manualAddressEntry"
                [class.error]="shouldShowError('state')" aria-label="State" aria-describedby="state-error"
                [attr.aria-invalid]="shouldShowError('state')">
              </ion-input>
            </ion-item>
            @if (shouldShowError('state')) {
            <div class="error-message" id="state-error" role="alert">
              @if (billingForm.get('state')?.errors?.['required']) {
              <span>Enter a valid pincode to fill the state</span>
              }
              @if (billingForm.get('state')?.errors?.['minlength']) {
              <span>State must be at least 2 characters</span>
              }
              @if (billingForm.get('state')?.errors?.['maxlength']) {
              <span>State must not exceed 50 characters</span>
              }
            </div>
            }
          </div>
        </div>

        <div class="form-field">
          <ion-item class="custom-input" [class.readonly]="!manualAddressEntry"
            [class.error]="shouldShowError('country')">
            <ion-input placeholder="Country *" formControlName="country" [readonly]="!manualAddressEntry"
              [class.error]="shouldShowError('country')" aria-label="Country" aria-describedby="country-error"
              [attr.aria-invalid]="shouldShowError('country')">
            </ion-input>
          </ion-item>
          @if (shouldShowError('country')) {
          <div class="error-message" id="country-error" role="alert">
            @if (billingForm.get('country')?.errors?.['required']) {
            <span>Enter a valid pincode to fill the country</span>
            }
            @if (billingForm.get('country')?.errors?.['minlength']) {
            <span>Country must be at least 2 characters</span>
            }
            @if (billingForm.get('country')?.errors?.['maxlength']) {
            <span>Country must not exceed 50 characters</span>
            }
          </div>
          }
        </div>

        <h3 sxMargin="24px 0 5px 10px" sxColor="two" sxTextSize="small">Are you a GST registered business?</h3>

        <div class="form-field">
          <ion-item class="custom-input" [class.error]="shouldShowError('gstin')">
            <ion-input placeholder="GSTIN" formControlName="gstin" [class.error]="shouldShowError('gstin')"
              aria-label="GSTIN (optional)" aria-describedby="gstin-error"
              [attr.aria-invalid]="shouldShowError('gstin')" maxlength="15">
            </ion-input>
          </ion-item>
          @if (shouldShowError('gstin')) {
          <div class="error-message" id="gstin-error" role="alert">
            @if (billingForm.get('gstin')?.errors?.['pattern']) {
            <span>GSTIN format is invalid</span>
            }
          </div>
          }
        </div>
      </form>
    </div>
  </div>

  <div class="w-96 bg-white rounded-md p-4">
    <div sxMargin="0 auto" sxCol sxGap="10px">
      <h1 sxMargin="18px 0 18px 5px" sxTextSize="large" sxTextWeight="bold">Order Summary</h1>

      <div class="p-2 flex flex-col gap-2">
        @if (items?.length) {
        @for (item of items; track item.organisation) {
        <div sxRow sxDistribution="spaceBetween">
          <div class="flex flex-col gap-1">
            <p class="text-base font-medium">{{ item.organisationName }}</p>
            <p class="text-sm text-gray-600">{{ item.plan.name }} Plan</p>
          </div>
          <p>₹{{ getItemAmount(item) }}</p>
        </div>
        }
        } @else {
        <div sxRow sxDistribution="spaceBetween">
          <div sxCol sxGap="5px">
            <p sxTextSize="medium">{{ plan.name }} Plan</p>
            @if (paymentTerms === TimePeriod.YEARLY) {
            <p sxTextSize="small" sxColor="two">for one year</p>
            }
            @if (paymentTerms === 'monthly') {
            <p sxTextSize="small" sxColor="two">for one month</p>
            }
          </div>
          <p>₹{{ planPricingModel?.amount }}</p>
        </div>
        }
        <div sxRow sxDistribution="spaceBetween" sxColor="two" sxTextSize="small" sxBorderWidth="1px 0 0 0"
          sxBorderColor="one" sxPadding="10px 0 0">
          <p>Discount</p>
          <p>- ₹{{ priceBreakup?.discountAmount?.toFixed(2) }}</p>
        </div>
        <div sxRow sxDistribution="spaceBetween" sxColor="two" sxTextSize="small">
          <p>GST (18%)</p>
          <p>₹{{ priceBreakup?.taxAmount?.toFixed(2) }}</p>
        </div>
        <div sxRow sxDistribution="spaceBetween" sxBorderWidth="1px 0 0 0" sxBorderColor="one" sxPadding="14px 0 10px"
          sxTextWeight="bold">
          <p>Total</p>
          <p>₹{{ priceBreakup?.payableAmount?.toFixed(2) }}</p>
        </div>
      </div>

      <div class="flex flex-row items-center justify-between bg-slate-50 p-4 rounded-md">
        <div class="flex flex-col">
          <p class="text-sm font-medium">Auto-renew</p>
          <p class="text-sm text-gray-600">
            @if (isAutoRenew) {
            Renews automatically. Cancel anytime.
            } @else {
            One-time payment. Renew manually later.
            }
          </p>
        </div>
        <ion-toggle color="dark" [(ngModel)]="isAutoRenew" aria-label="Auto-renew"></ion-toggle>
      </div>

      <super-button [showError]="true" [action]="completePaymentClicked" iconEnd="chevron-forward"
        aria-label="Complete payment">
        Continue to Payment
      </super-button>
    </div>
  </div>
</div>
} @else {

<div class="payment-status w-full flex flex-col justify-center items-center">
  <div class="payment-card" [class.processing]="paymentPhase === 'processing'"
    [class.success]="paymentPhase === 'success'" [class.failed]="paymentPhase === 'failed'" sxPadding="medium"
    sxWidth="400px" sxHeight="500px" sxCenterize="col" sxRadius="large" sxBorderWidth="1px" sxGap="10px">

    <div class="status-indicator">
      @if (paymentPhase === 'processing') {
      <ion-spinner name="crescent" class="payment-spinner"></ion-spinner>
      }
      @if (paymentPhase === 'success') {
      <ion-icon name="checkmark-circle" class="success-checkmark"></ion-icon>
      }
      @if (paymentPhase === 'failed') {
      <ion-icon name="close-circle" class="failed-icon"></ion-icon>
      }
    </div>

    <h1 class="payment-title" sxTextSize="large" sxTextWeight="bold">
      @switch (paymentPhase) {
      @case ('processing') { Processing Your Payment }
      @case ('success') { Payment Successful }
      @case ('failed') { Payment Failed }
      }
    </h1>

    <p class="payment-description" sxTextSize="small" sxTextAlign="center">
      @switch (paymentPhase) {
      @case ('processing') { Please wait while we confirm your payment. This can take a little while — please don't
      close
      this window. }
      @case ('success') { Your payment has been processed successfully }
      @case ('failed') { {{ paymentErrorMessage }} }
      }
    </p>

    @if (paymentPhase === 'processing' && showRecheckStatus) {
    <super-button size="small" sxMargin="20px 0 20px" [action]="recheckPaymentStatus" iconEnd="refresh"
      aria-label="Recheck payment status">
      Recheck status
    </super-button>
    }

    @if (paymentPhase === 'success') {
    <div class="progress-button success-button" role="status" aria-live="polite" aria-label="Redirecting to billing">
      <span class="progress-fill"></span>
      <span class="progress-label">Back to Billing</span>
    </div>
    }

    @if (paymentPhase === 'failed') {
    <super-button size="small" sxMargin="20px 0 20px" [action]="retryPayment" iconEnd="refresh"
      aria-label="Try payment again">
      Try Again
    </super-button>
    }
  </div>
</div>
}